// frontend urls
const frontend_local_url = 'localhost'
const frontend_dev_url = 'amrak-dev-sms.unicloud360.com'
const frontend_staging_url = ''
const frontend_prod_url = 'sms.amrak.lk'

export const __DEV__ = window.location.hostname === frontend_local_url
export const __TESTING__ = window.location.hostname === frontend_dev_url
export const __STAGING__ = window.location.hostname === frontend_staging_url
export const __PROD__ = window.location.hostname === frontend_prod_url

export const frontend_local = `http://${frontend_local_url}:3000`
export const frontend_dev = `https://${frontend_dev_url}`
export const frontend_staging = `https://${frontend_staging_url}`
export const frontend_prod = `https://${frontend_prod_url}`

// backend urls
export const backend_mock = ''
export const backend_dev = 'https://common-dev-api.unicloud360.com'
export const backend_prod = 'https://common-api.unicloud360.com'